import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputValidate, TextInputViewModel, WithKey } from 'src/app/domain/presenter/viewmodel/input.view.model';

@Component({
  selector: 'app-text-input',
  imports: [CommonModule, FormsModule],
  templateUrl: './text-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    }
  ]
})
export class TextInputComponent implements OnInit, ControlValueAccessor {
  @Input() viewModel?: TextInputViewModel;
  @Input() type = 'text';
  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() isValid = true;
  @Input() errorMessage?: string;
  @Output() didChange = new EventEmitter<WithKey>();

  id = '' + Math.random();
  initialValue?: string;
  caption?: string = undefined;
  value = '';

  onChange: any = () => {};
  onTouched: any = () => {};

  ngOnInit(): void {
    if (this.viewModel) {
      this.initialValue = this.viewModel.value;
      this.value = this.viewModel.value ?? '';
    }
  }

  inputHandler(event: Event) {
    const newValue = (event.target as HTMLInputElement).value;

    if (this.viewModel) {
      this.viewModel.pristine = false;
      this.viewModel.focused = true;
      this.viewModel.value = newValue;
      this.viewModel.dirty = (this.initialValue !== newValue);
      this.caption = undefined;

      if (this.viewModel.validate) {
        this.viewModel.valid = this.viewModel.validate
          .map((v) => v(newValue) === undefined)
          .reduce((a, b) => a && b, true);
      }

      this.didChange.emit(this.viewModel);
    } else {
      this.value = newValue;
      this.onChange(newValue);
      this.onTouched();
    }
  }

  blurHandler(event: FocusEvent) {
    if (this.viewModel) {
      this.viewModel.touched = true;
      this.viewModel.focused = false;

      this.caption = this.viewModel.validate
        .map((v: InputValidate) => v(this.viewModel!.value))
        .filter((m: string | undefined) => m !== undefined)
        .join(', ');
    } else {
      this.onTouched();
    }
  }

  writeValue(obj: any): void {
    this.value = obj ?? '';
    if (this.viewModel) {
      this.viewModel.value = this.value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
